<template>
    <div id="app">
        <el-container class="ciyemian_yibei_qiangzhi_buxudong flextext">
            <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no">
            <home-head></home-head>
            <el-main>
                <div class="contain">
                    <div class="small-title">{{list.title}}</div>
                    <el-row :gutter="30">
                        <el-col :xs="24" :sm="24" :md="9">
<!--  <el-image class="shop" :src="url+'/storage/'+list.cover" fit="cover">-->
                             <div  class="shop_list">
                                 <el-image  class="shop1" :src="url+'/storage/'+list.cover" fit="cover">
                                <div slot="error" class="image-slot">
                                    <img class="weijiazai_img_qiangzhi"
                                         src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png"
                                         alt="" style="height: 360px" width="250px">
                                </div>
                            </el-image>
                             </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="15 ">
                            <div class="shop-span" >
                                <ul style="position: absolute">
                                    <li v-if="list.jiaofu==2">
                                        现货
                                    </li>
                                    <li v-if="list.jiaofu==3">
                                        订货
                                        <div class="jiaofu_time">{{ list.jiaofu_date + '天' }}</div>
                                    </li>
                                </ul>
                            </div>
                            <div style="margin-bottom: 30px;margin-left: 40px">
                                <div>
            <span class="prices" v-if="list.price_yugu==0.00">明码标价
            <span class="moneys">¥</span><span class="value">{{list.cash}}</span>
            </span>
                                    <span class="prices" v-else>预估价格
                <span class="moneys">¥</span><span class="value">{{list.price_yugu}}</span>
                  </span>
                                </div>
                                <div class="guige_tou" v-if="list.attachment[0]">
                                    <span style="margin-right: 65px; float: left">附件</span>
                                    <a :href="url+'/storage/'+list.attachment[0].url"
                                       target=“_blank”
                                       style="display: block; float: left; margin-left: 35px">
                                        <el-link type="primary">{{ list.attachment[0].name }}</el-link>
                                    </a>
                                </div>

                                <div class="guige_tou" v-if="list.cert_file[0]">
                                    <span style="margin-right: 65px; float: left">必要资质</span>
                                    <a :href="url+'/storage/'+list.cert_file[0].url" style="display: block; float: left"
                                       target=“_blank”>
                                        <el-link type="primary">{{ list.cert_file[0].name}}</el-link>
                                    </a>
                                </div>
                                <!--              <div class="guige_middle">-->
                                <!--                <div class="zizhi">必要资质</div>-->
                                <!--&lt;!&ndash;                <a :href="url+'/storage/'+list.cert_file.url" style="display: block; float: left">&ndash;&gt;-->
                                <!--&lt;!&ndash;                  <el-link type="primary">{{list.cert_file.name}}</el-link>&ndash;&gt;-->
                                <!--&lt;!&ndash;                </a>&ndash;&gt;-->
                                <!--              </div>-->
                            </div>
                            <el-divider class="hr" ></el-divider>
                            <!--                <span class="prices-one" :key="index2">-->
                            <!--                    <span style="display: block; float: left">规格型号</span>-->
                            <!--                              <span class="moneys-num" :style="index2==0?'':'margin-left:135px; width:100px'">{{}}</span>-->
                            <!--                    <span class="moneys-nums" style="width: 100px" >123元</span>-->
                            <!--                  <span class="moneys-nums" style="width: 100px" >234元</span>-->
                            <!--                  <span class="jibuqi">-->
                            <!--                                <el-input-number size="mini"  @change="handleChange2" :min="0" :max="10"-->
                            <!--                                                 label="描述文字"></el-input-number>-->
                            <!--                    </span>-->
                            <!--                </span>-->
                            <!--              <div v-if="item.price=='0.00'">-->
                            <!--                <span class="moneys-num" :style="index2==0?'':'margin-left:135px; width:100px'">{{item.estimate}}</span>-->
                            <!--                <span class="moneys-nums" style="width: 100px" v-if="item.sum!==0">{{ item.estimate * item.sum }}元</span>-->
                            <!--                <span class="moneys-nums" style="width: 100px" v-else>{{item.estimate * 1}}元</span>-->
                            <!--              </div>-->
                            <span class="prices-one" v-for="(item,index2) in list_guige" :key="index2" >
             <span style="display: block; float: left" v-if="index2==0">规格型号</span>
                                <!--                <div></div>-->
            <span class="moneys-num"
                  :style="index2==0?'':'margin-left:135px; width:100px'">{{item.specification}}</span>
                                <!--                  <span class="moneys-num"-->
                                <!--                        style="margin-left:70px; width:150px;overflow:hidden;font-size:14px">{{item.specification}}</span>-->
            <span class="moneys-nums" style="width: 100px" v-if="item.price=='0.00'&&item.sum!==0">{{ item.estimate * item.sum }}元</span>
                <span v-if="item.price=='0.00'&&item.sum==0" class="moneys-nums" style="width: 100px">{{item.estimate * 1}}元</span>
                <span class="moneys-nums" style="width: 100px" v-if="item.price!=='0.00'&&item.sum!==0">{{ item.price * item.sum }}元</span>
                <span v-if="item.price!=='0.00'&&item.sum==0" class="moneys-nums" style="width: 100px">{{item.price * 1}}元</span>
                <span class="jibuqi">
            <el-input-number size="mini" v-model="item.sum" @change="handleChange2" :min="0" :max="10"
                             label="" class=""></el-input-number>
              </span>
              <el-divider class="hrs"></el-divider>
              </span>

                            <!--            <span class="prices-one" v-for="(item,index2) in list.specification" :key="index2" style="margin-left: 80px">-->
                            <!--            <span class="moneys-num">{{ item.specification }}</span>-->
                            <!--            <span class="moneys-nums">{{item.price}}元</span>-->
                            <!--              <span class="jibuqi">-->
                            <!--            <el-input-number  size="mini" v-model="num[index2]" @change="handleChange2" :min="0" :max="10"-->
                            <!--                              label="描述文字"></el-input-number>-->
                            <!--              </span>-->
                            <!--              </span>-->
                            <!--            <el-divider class="hrs"></el-divider>-->
                            <!--            <div class="guige_tou" style="margin-bottom: 30px" v-if="list.attachment[0]">-->
                            <!--              <span style="margin-right: 65px">附件</span>-->
                            <!--              <a :href="url+'/storage/'+list.attachment[0].url">-->
                            <!--                <el-link type="primary">{{list.attachment[0].name}}</el-link>-->
                            <!--              </a>-->
                            <!--            </div>-->
                            <span class="buy">
<!--            <a :href="'#/purchase/'+list.id">-->

          <el-button @click="goumai_sj(list.id)" class="buy-button" type="primary">立即购买</el-button>
                                <!--              </a>-->
            </span>
                            <span class="buy">
<!--            <a :href="'#/details/'+list.id">-->
          <el-button class="buy-button" type="primary" v-if="status"
                     @click="shouce(list.id)">{{ status }}</el-button>
                                <!--              </a>-->
            </span>
                        </el-col>
                        <!--            <div class="guige_tou" style="margin-bottom: 30px" v-if="list.attachment[0]">-->
                        <!--            <span class="prices-one" >附件</span>-->
                        <!--            <a href="url+'/storage/'+list.attachment[0].url" class="moneys-img">asdfghjkli.jpg</a>-->
                        <!--              <el-link type="primary">{{list.attachment[0].name}}</el-link>-->
                        <!--            </div>-->
                    </el-row>
                    <div style="margin-bottom: 40px; height: 400px; width: 100%">
                        <div class="aaa hidden-sm-and-down">
                            <div class="xinxi">
                                <!--                <div class="xinxi3">-->

                                <!--                  <div class="title-gs">店铺名称：{{ inform.shop_name }}</div>-->
                                <!--                </div>-->
                                <el-row :gutter="2" class="lxtop">
                                    <el-col class="word-shop" :span="9" :offset="2">店铺名称：</el-col>
                                    <el-col class="word-shop" :span="9">{{ inform.shop_name }}</el-col>
                                </el-row>

                                <el-divider class="hengxian"></el-divider>
                                <el-row :gutter="2" class="lxtop">
                                    <el-col class="word-shop" :span="9" :offset="2">用户名:</el-col>
                                    <el-col class="word-shop" :span="9">{{ inform.name}}</el-col>
                                </el-row>
                                <el-row :gutter="2" class="lxtop">
                                    <el-col class="word-shop" :span="9" :offset="2">联系方式:</el-col>
                                    <el-col class="word-shop" :span="9">{{ inform.mobile }}</el-col>
                                </el-row>
                                <el-row :gutter="2" class="lxtop">
                                    <el-col class="word-shops" :span="9" :offset="2"> 所在区域:</el-col>
                                    <el-col class="word-shops" :span="9">{{sheng}}{{shi}}{{qv}}</el-col>
                                </el-row>
                                <div class="buttons">
                                    <button><a :href="'#/shops/index/'+list.shop_id">进入店铺</a></button>
                                </div>
                            </div>
                        </div>
                        <div class="bottom_right_background">
                            <el-tabs v-model="activeName" @tab-click="handleClick">
                                <el-tab-pane label="详情描述" name="first">
                                    <div class="xiangqing_background1"></div>
                                    <div class="xiangqing_background">
                                        <!--                    <div class="xiangqing_title" style="float: left;margin-left: 23px">-->
                                        <!--                      关键指标参数：<span>{{list.key_index}}</span>-->
                                        <!--                    </div>-->
                                        <!--                    <div class="xiangqing_title" style="float: left;margin-left: 90px">-->
                                        <!--                      应用行业：<span>{{yingyong_hy}}</span>-->
                                        <!--                    </div>-->
                                        <!--                    <div class="xiangqing_title" >-->
                                        <!--                      <span class="tanxing" >关键指标参数：{{list.key_index}}</span>-->
                                        <!--                      <span class="tanxing"> 应用行业：{{yingyong_hy}}</span>-->
                                        <!--                    </div>-->

                                        <!--                    <div class="xiangqing_title " style="float: left;margin-left: 23px">-->
                                        <!--                      关键指标参数：<span class="tanxing" >{{list.key_index}}</span>-->
                                        <!--                    </div>-->
                                        <!--                    <div class="xiangqing_title " style="float: left;margin-left: 23px">-->
                                        <!--                     <div v-for="(list,block_index) in design_block" :key="block_index">-->
                                        <!--                         <div>-->
                                        <!--                             <block v-for="(word,key_index) in block.keywords" v-bind:key="key_index">-->
                                        <!--                                 <block v-if="key_index % 2 == 0">-->
                                        <!--                                     <el-row>-->
                                        <!--                                         <el-col>-->
                                        <!--                                             {{list[key_index]}}-->
                                        <!--                                         </el-col>-->
                                        <!--                                         <el-col v-if="block.keywords[key_index=1]">-->
                                        <!--                                             {{list[key_index+1]}}-->
                                        <!--                                         </el-col>-->
                                        <!--                                     </el-row>-->
                                        <!--                                 </block>-->
                                        <!--                             </block>-->
                                        <!--                         </div>-->
                                        <!--                     </div>-->
                                        <!--                      <div class="xiangqing_title" style="float: left;margin-left: 23px">-->
                                        <div class="xiangqing_title">
                                            <span style="float: left;margin-left: 23px"> 关键指标参数：</span>
                                            <span>
                          <el-row v-for="(item,index) in list.key_index.split(',')" v-bind:key="index"
                                  style="display: flex">
                              <el-col v-if="index % 2 == 0" class="title">
                                 <block> {{list.key_index.split(',')[index]}}</block>
                                  <block class="title_list">{{list.key_index.split(',')[index+1]}}</block>
                              </el-col>
                          </el-row>
                          </span>

                                        </div>
                                        <div class="xiangqing_title">
                                            <span style="float: left;margin-left: 90px">行业领域:</span>
                                            <span>
                          <el-row v-for="(item,index) in yingyong_hy.split(',')" v-bind:key="index"
                                  style="display: flex">
                              <el-col v-if="index % 2 == 0" class="title">
                                  <block> {{yingyong_hy.split(',')[index]}}</block>
                                 <block class="title_list">  {{yingyong_hy.split(',')[index+1]}}</block>
                              </el-col>
                          </el-row>
                          </span>
                                        </div>
                                        <div class="julizhi"></div>
                                    </div>
                                    <div class="clear">
                                    </div>
                                    <div class="xiangqing_background1"></div>
                                    <div class="bottom_titlemiaoshu imgsize" v-html="list.desc"></div>
                                </el-tab-pane>
                                <el-tab-pane label="配置方案" name="second">
                                    <div class="xiangqing_background1"></div>
                                    <div class="bottom_titlemiaoshu" v-html="list.configuration"></div>
                                </el-tab-pane>
                                <el-tab-pane label="案例解析" name="third">
                                    <div class="xiangqing_background1"></div>
                                    <a v-if="list.list_cases[0]" v-bind:href="'#/case_details/'+ list.list_cases[0].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_cases[0].title"></div>
                                    </a>
                                    <a v-if="list.list_cases[1]" v-bind:href="'#/case_details/'+ list.list_cases[1].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_cases[1].title"></div>
                                    </a>
                                    <a v-if="list.list_cases[2]" v-bind:href="'#/case_details/'+ list.list_cases[2].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_cases[2].title"></div>
                                    </a>
                                </el-tab-pane>
                                <el-tab-pane label="小星点灯" name="fourth">
                                    <div class="xiangqing_background1"></div>
                                    <!--                  <div v-if="list.list_light[0]!==''" class="bottom_titlemiaoshu"  v-html="list.list_light[0].title"></div>-->
                                    <a v-if="list.list_light[0]"
                                       v-bind:href="'#/lighting_details/'+ list.list_light[0].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_light[0].title"></div>
                                    </a>
                                    <a v-if="list.list_light[1]"
                                       v-bind:href="'#/lighting_details/'+ list.list_light[1].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_light[1].title"></div>
                                    </a>
                                    <a v-if="list.list_light[2]"
                                       v-bind:href="'#/lighting_details/'+ list.list_light[2].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_light[2].title"></div>
                                    </a>
                                </el-tab-pane>
                                <el-tab-pane label="应用方案" name="fifth">
                                    <div class="xiangqing_background1"></div>
                                    <a v-if="list.list_applicationProgram[0]"
                                       v-bind:href="'#/college/programme/'+ list.list_applicationProgram[0].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_applicationProgram[0].title"></div>
                                    </a>
                                    <a v-if="list.list_applicationProgram[1]"
                                       v-bind:href="'#/college/programme/'+ list.list_applicationProgram[1].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_applicationProgram[1].title"></div>
                                    </a>
                                    <a v-if="list.list_applicationProgram[2]"
                                       v-bind:href="'#/college/programme/'+ list.list_applicationProgram[2].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_applicationProgram[2].title"></div>
                                    </a>
                                </el-tab-pane>
                                <el-tab-pane label="行业标准" name="sixth">
                                    <div class="xiangqing_background1"></div>
                                    <a v-if="list.list_norm[0]"
                                       v-bind:href="'#/college/standard/'+ list.list_norm[0].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_norm[0].title"></div>
                                    </a>
                                    <a v-if="list.list_norm[1]"
                                       v-bind:href="'#/college/standard/'+ list.list_norm[1].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_norm[1].title"></div>
                                    </a>
                                    <a v-if="list.list_norm[2]"
                                       v-bind:href="'#/college/standard/'+ list.list_norm[2].id">
                                        <div style="word-break:break-all;" class="bottom_titlemiaoshu"
                                             v-html="list.list_norm[2].title"></div>
                                    </a>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </div>
            </el-main>
            <header_dian
            :dzhi="dzhi"></header_dian>
            <footerall></footerall>
        </el-container>
    </div>
</template>
<script>
    import home_head from '../../common/home-head';
    import {CodeToText} from 'element-china-area-data'
    import footerall from "../../common/footer";
    import headerdianpu from "../shops/common/header";
    // import Block_nav from "../../houtai/common/nav";
    // import Block_nav from "../../houtai/common/nav";
    export default {
        name: "category",
        data: function () {
            return {
                favorite: false,
                is_open: {
                    sousuo: 1,
                    lanmu: 1,
                },
                dzhi: 30,
                value: 5,
                status: '',
                activeName: 'first',
                list: '',
                list_guige: [],
                // yingyong_hy : [],
                url: '',
                num: [
                    '', '', ''
                ],
                information: '',

                inform: "",
                sheng: '',
                shi: '',
                qv: '',
                anli: [],
                diandeng: [],
                fangan: [],
                biaozhun: [],
                yingyong_hy: [],
            }
        },
        components: {
            // Block_nav,
            // Block_nav,
            'home-head': home_head,
            'header_dian':headerdianpu,
            footerall
        },
        methods: {

            sousuo_xuanxiang(e) {
                this.is_open.sousuo = e
                console.log(this.is_open.sousuo)

            },

            init() {
                this.information = this.$store.state.information
                this.url = window.config.api_url;

                console.log(window.config.api_url);
                this.list_data()
                this.zhuangtai()
                // this.dp_inform()
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            zhuangtai() {
                var t = this
                var id = localStorage.getItem('token');
                var url = window.config.api_url + '/user/goods/focus/check/' + t.$route.params.id + '?token=' + id
                t.axios.get(url).then(res => {
                    t.status = res.data.focus
                    // console.log(res,89444444444)
                    // t.status = res.data.focus == 0 ? '收藏商品' : '已收藏'
                    t.status = res.data.focus == 1 ? '已收藏' : '收藏商品'
                })
            },
            shouce() {
                // console.log(cet);
                var t = this
                var id = localStorage.getItem("uid")
                var formData = new FormData();
                formData.append('token', id);
                formData.append('goods_id', this.$route.params.id);
                if (t.status == '收藏商品') {
                    var url = window.config.api_url + '/user/goods/focus'
                    t.axios.post(url, formData).then(res => {
                        console.log(res)
                        t.$code(res.data.status)
                        if (res.data.status == 0) {
                            t.open2('成功')
                            // 接口调用成功
                            this.$router.go(0);
                        }
                    })
                    this.status = '已收藏'
                } else {
                    var url1 = window.config.api_url + '/user/goods/unfocus'
                    t.axios.post(url1, formData).then(res => {
                        // console.log(res)
                        t.$code(res.data.status)
                        if (res.data.status == 0) {  // 接口调用成功
                            t.open2('成功')
                            // this.status = '收藏商品'// 要改成的值
                            this.$router.go(0);
                        }
                    })
                    this.status = '收藏商品'
                }
            },
            dp_inform() {
                var t = this
                var url = window.config.api_url + '/college/shop/info?id=' + t.list.shop_id
                t.axios.get(url).then(res => {
                    t.inform = res.data;
                    t.dzhi=res.data.id;
                    console.log("2222121212122321321", res.data.id);
                    CodeToText[res.data.auth_info.province] === undefined ? t.sheng = res.data.auth_info.province_name : t.sheng = CodeToText[res.data.auth_info.province]
                    CodeToText[res.data.auth_info.city] === undefined ? t.shi = res.data.auth_info.city_name : t.shi = CodeToText[res.data.auth_info.city];
                    CodeToText[res.data.auth_info.area] === undefined ? t.qv = res.data.auth_info.area_name : t.qv = CodeToText[res.data.auth_info.area];
                    // t.sheng = CodeToText[res.data.auth_info.province];
                    // t.shi = CodeToText[res.data.auth_info.city];
                    // t.qv = CodeToText[res.data.auth_info.area];
                })
            },
            goumai_sj(e) {
                var t = this;
                var list_vu = [];
                t.list_guige.forEach(function (item) {
                    if (item.sum !== 0) {
                        list_vu.push({
                            estimate: item.estimate,
                            goods_id: item.goods_id,
                            id: item.id,
                            price: item.price,
                            specification: item.specification,
                            sum: item.sum
                        })
                    }
                })
                if (list_vu == '') {
                    return t.$message.error('请至少选择一个商品规格');
                }
                t.$store.commit('saveDbSource', list_vu)
                window.location = "#/purchase/" + e
            },
            list_data() {
                var t = this
                var url = window.config.api_url + '/college/goods/' + t.$route.params.id
                t.axios.get(url).then(res => {

                    // console.log(url,123123123)
                    t.list = res.data
                    // console.log("23232res",res.data)
                    for (let i = 0; i < t.list.aac.length; i++) {
                        t.yingyong_hy.push(t.list.aac[i].title)
                    }
                    t.yingyong_hy = t.yingyong_hy.join(',')

                    // for (let i=0;i<t.list.list_cases.length;i++){
                    //   t.anli.push(t.list.list_cases[i].title)
                    // }
                    // t.anli=t.anli.join('<br/>\n')
                    //
                    //
                    // for (let i=0;i<t.list.list_light.length;i++){
                    //
                    //   t.diandeng.push(t.list.list_light[i].title)
                    // }
                    // t.diandeng=t.diandeng.join('<br/>\n')
                    //
                    // for (let i=0;i<t.list.list_applicationProgram.length;i++){
                    //   t.fangan.push(t.list.list_applicationProgram[i].title)
                    // }
                    // t.fangan=t.fangan.join('<br/>\n')
                    //
                    // for (let i=0;i<t.list.list_norm.length;i++){
                    //   t.biaozhun.push(t.list.list_norm[i].title)
                    // }
                    // t.biaozhun=t.biaozhun.join('<br/>\n')
                    // console.log(t.fangan,123123123)
                    //  = res.data.specification
                    res.data.specification.forEach(function (item) {
                        t.list_guige.push({
                            estimate: item.estimate,
                            goods_id: item.goods_id,
                            id: item.id,
                            price: item.price,
                            specification: item.specification,
                            sum: 0
                        })
                        // console.log(item)
                    })

                    console.log(t.list_guige)
                    t.dp_inform()
                })

            },
            fujiaxz(e) {
                this.$router.push(this.url + '/storage/' + e);
            },
            handleChange2(e) {
                this.$store.commit('savePath', e)

            },
            // //22332345
            //    get_design_block:function(){
            //        var t = this
            //        var url = window.config.api_url + '/college/shop/info' + 'id=2'
            //        t.axios.get(url).then( res => {
            //                res.key_index = Array.isArray( res.key_index )
            //                    ? res.key_index
            //                    : res.key_index.split(',');
            //        })
            //
            //    }


        },

        created() {
            this.init();
        },
        beforeRouteEnter(to, from, next) {
         console.log("to122",to,from)
            next();
        }

    }

</script>
<style lang="less">
    .home_shop_xiang_peizhi_qiangzhi_elementui_leixing {
        .el-tabs__nav-wrap::after {
            background-color: #FFFFFF !important;
            width: 0;
        }
    }

</style>


<style>
    .julizhi {
        margin-top: 10px;
    }

    .ciyemian_yibei_qiangzhi_buxudong .el-tabs__active-bar {
        background-color: #4E6EF2;
        left: 1px;
        width: 58px !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .el-icon-arrow-left:before {
        display: none !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .el-icon-arrow-right:before {
        display: none !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
        /*padding: 0 14px!important;*/
        /*font-size: 14px!important;*/
        line-height: 47px;
        font-size: 18px !important;
        padding-right: 83px !important;
        /*margin-right: 88px;*/
        /*padding: 0 44px!important;*/
        height: 45px;
        font-weight: bold;
        color: #333333;
    }

    .el-tabs__nav-scroll {
        margin-left: 45px;
    }

    .ciyemian_yibei_qiangzhi_buxudong .el-tabs__item {
        padding: 0 !important;
        width: 120px !important;

    }

    .ciyemian_yibei_qiangzhi_buxudong .el-tab-pane {

        margin-left: 35px !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2_bottom[data-v-7edfb125] {
        left: -10px;
    }

    @media screen and (min-width: 995px) and (max-width: 1500px) {

        .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
            width: 100% !important;
        }

        .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
            padding-right: 25px !important;
            /*margin-right: 26px;*/
            font-size: 15px !important;
            /*padding-left: 25px;*/
            height: 45px;
            font-weight: bold;
            color: #333333;
        }
    }

    @media screen and (min-width: 750px) and (max-width: 995px) {
        .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
            width: 100% !important;
        }

        .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
            padding-right: 24px !important;
            font-size: 16px !important;
            height: 45px;
            font-weight: bold;
            color: #333333;
        }

        .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 {
            width: 100%;
            position: relative;
            box-sizing: border-box;
            padding-left: 0px !important;
            margin-top: 25px;

        }
    }

    @media screen and (max-width: 750px) {
        .ciyemian_yibei_qiangzhi_buxudong .contain .shop{
            width: 100% !important;
        }

        .ciyemian_yibei_qiangzhi_buxudong .contain {
            width: 100% !important;
        }

        .ciyemian_yibei_qiangzhi_buxudong .moneys-num {
            margin-left: 55px !important;
        }

        .ciyemian_yibei_qiangzhi_buxudong .moneys-nums {
            margin-left: 45px !important;
        }

        .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
            padding-right: 4px !important;
            font-size: 13px !important;
            height: 45px;
            font-weight: bold;
            color: #333333;
        }

        .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 {
            width: 100%;
            position: relative;
            box-sizing: border-box;
            padding-left: 0px !important;
            margin-top: 25px;

        }

        .ciyemian_yibei_qiangzhi_buxudong .jibuqi {
            margin-left: 50px !important;
        }
    }

    .ciyemian_yibei_qiangzhi_buxudong .el-tabs__header {
        margin-bottom: 0px !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2_bottom div {
        margin-left: 23px;
        margin-right: 40px !important;
        float: left;
        font-size: 14px;
        color: #666666;
        line-height: 60px;
    }

    .jibuqi {
        margin-left: 68px;
    }

    .jibuqi .el-input__inner {
        padding: 0;
        border: 0px;
    }

    .ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-icon-minus:before {
        font-size: 14px !important;
        color: #FFFFFF;
        font-weight: bold;
        content: "\e6d8";
    }

    .ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-icon-plus:before {
        font-size: 14px !important;
        color: #FFFFFF;
        font-weight: bold;
        content: "\e6d9";
    }

    .jibuqi .el-input-number--mini {
        width: 98px;
    }

    .ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-input-number__increase {
        width: 27px;
        background: #4E6EF2 !important;
    }

    .ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-input-number__decrease {
        width: 27px;
        background: #4E6EF2 !important;
    }

    .imgsize p img {
        max-width: 100%
    }
</style>
<style lang="less" scoped>
    @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

    @head_text: Source Han Sans CN;
    @font-face {

    }

    @import "../../../assets/css/home";
    @import "../../../assets/css/home_details";
    //@import "../../../assets/css/goods_detailed";
    .flextext {
        display: flex;
        flex-direction: column;
        flex: 1;
        flex-basis: auto;
        box-sizing: border-box;
        min-width: 0;
    }

    .btncss {
        position: absolute;
    }
</style>